module.exports = __webpack_public_path__ + "static/media/astronomy-completed.e84b41ee.svg";